// pages/Organization/Organization.tsx
import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import TabNavigation from "../../components/layout/TabNavigation";
import { organizationTabs } from "../../config/tabs";

const Overview = lazy(() => import("./tabs/Overview/Overview"));
const RolesTab = lazy(() => import("./tabs/Roles/RolesTab"));
const MembersTab = lazy(() => import("./tabs/Members/MembersTab"));
const DepartmentsTab = lazy(() => import("./tabs/Departments/DepartmentsTab"));
const OrgChartTab = lazy(() => import("./tabs/OrgChart/OrgChartTab"));

const Organization: React.FC = () => {
  return (
    // Fill the available height provided by Layout/main
    <div className="org-page h-full flex flex-col p-4 sm:p-6">
      {/* Header area should not grow/shrink the content height */}
      <div className="shrink-0">
        <TabNavigation tabs={organizationTabs} />
      </div>

      {/* Content area becomes the height owner for tabs */}
      <div className="org-content flex-1 min-h-0 overflow-hidden">
        <Suspense fallback={<div className="loading-spinner p-4">Cargando...</div>}>
          {/* Make Routes fill so nested tab pages can use h-full */}
          <div className="h-full">
            <Routes>
              <Route index element={<Overview />} />
              <Route path="roles" element={<RolesTab />} />
              <Route path="departments" element={<DepartmentsTab />} />
              <Route path="members" element={<MembersTab />} />
              <Route path="org-chart" element={<OrgChartTab />} />
            </Routes>
          </div>
        </Suspense>
      </div>
    </div>
  );
};

export default Organization;
